import SymphonyPurpleLogo from 'assets/images/logos/symphony-badge-purple.png';
import SymphonyBlackLogo from 'assets/images/logos/symphony-badge-black.png';
import { styx } from 'modules/Utils';

interface SymphonyLogoProps {
    width: number;
    height: number;
    variant?: 'purple' | 'black';
    style?: React.CSSProperties;
}

const SymphonyLogo = ({
    width,
    height,
    variant,
    style,
}: SymphonyLogoProps) => {
    switch (variant) {
        case 'purple':
            return <img src={SymphonyPurpleLogo} height={height} width={width} alt="Symphony Purple Logo" style={style} />
        case 'black':
            return <img src={SymphonyBlackLogo} height={height} width={width} alt="Symphony Black Logo" style={style} />
        default:
            return <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 52 8"
                height="12px"
                preserveAspectRatio="xMidYMid meet"
                style={styx(
                    {
                        height: 'auto',
                        width: 'auto',
                    },
                    style
                )}
                fill="none"
            >
                <path
                    fill="#fff"
                    d="M5.704 5.177c0-1.027-.84-1.867-1.867-1.867h-1.95a.52.52 0 0 1-.518-.518v-.394a.52.52 0 0 1 .518-.519H4.77L5.185.5H1.867C.84.5 0 1.34 0 2.367v.456C0 3.85.84 4.69 1.867 4.69h1.939c.29 0 .518.228.518.518v.405a.52.52 0 0 1-.518.518H.415L0 7.5h3.837c1.027 0 1.867-.84 1.867-1.867v-.456ZM11.934.5h-1.648L8.76 2.76 7.247.5H5.598l1.877 2.81h.923l-.321.477V7.5h1.38V4.213L11.934.5Zm5.563 0L15.66 3.518 13.826.5h-1.37v7h1.37V3.144l1.306 2.147h1.058l1.307-2.147V7.5h1.369v-7h-1.37Zm8.056 3.028v.031-.03Zm0-1.192v.03-.03Zm0 .03v-.03A1.872 1.872 0 0 0 23.687.5h-3.838v7h1.37V1.88h2.436c.29 0 .519.227.519.518v1.099c0 .29-.228.519-.518.519h-1.483l-.415 1.379h1.929c1.016 0 1.845-.82 1.866-1.836V2.367ZM31.668.5h-1.38v2.81h-1.741l-.695.695V.5h-1.369v7h1.369V4.69h2.437V7.5h1.38v-7Zm4.612 0h-1.763c-1.027 0-1.867.84-1.867 1.867v3.266c0 1.027.84 1.867 1.867 1.867h1.763c1.027 0 1.867-.84 1.867-1.867V2.367C38.147 1.34 37.307.5 36.28.5Zm.487 5.113a.52.52 0 0 1-.518.518h-1.711a.527.527 0 0 1-.519-.518V2.398a.52.52 0 0 1 .519-.519h1.711c.29 0 .518.228.518.519v3.215Zm7.758 1.503V.5h-1.38v4.356L40.501.5h-1.369v7h1.369V3.144L43.145 7.5h1.38v-.384ZM51.33.5H49.68l-1.524 2.26L46.643.5h-1.65l1.878 2.81h.923l-.322.477V7.5h1.38V4.213L51.33.5Z"
                />
            </svg>
    }
}

export default SymphonyLogo